import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"fill-current\" id=\"plus\"><path d=\"M13.71 24h-3.42V13.71H0v-3.42h10.29V0h3.42v10.29H24v3.42H13.71V24z\" data-name=\"Icons-/-Large-/-Primary-/-Plus\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol